<template>
    <!-- <a-spin :spinning="spinning" class="spin-box" :tip="$t('spin.text')"> -->
        <v-form
            ref="applyForm"
            v-model="valid"
            class="formStyle"
        >
            <p class="selectTitle">{{ $t('adhibition.selectAppType') }}</p>
            <v-radio-group
                v-model="form.appSelect"
                row
            >
                <div class="login-index-loading-box" v-if="isLoading">
                    <v-progress-circular
                    :size="23"
                    :width="2"
                    color="#6A1B9A"
                    indeterminate
                    ></v-progress-circular>
                </div>
                <div class="topBox"  :class="$vuetify.theme.dark ? 'list-dark':''" v-else>
                    <template v-if="appSelectData.length>0">
                        <v-col cols="12" md="3" lg="3" xl="3" sm="4" v-for="(item,index) in appSelectData" :key="index" class="colStyle">
                            <div class="appSelect_box" >
                              <img v-if="item.logoBase64" :src="'data:image/png;base64,'+item.logoBase64" alt="" class="appImg">
                              <v-img v-else-if="item.logoUrl" class="appImg" allow-overflow :src="require('@/assets/img/'+ item.logoUrl)"></v-img>
                              <!-- <v-img v-else class="logo-pic" allow-overflow src="@/assets/img/app-default-img.png"></v-img> -->
                              <img v-else src="@/assets/img/app-default-img.png" alt="" class="appImg" >

                                <!-- //当前应用如果有权限申请记录的 当前审核情况 状态 0 .待审批 1.已同意 2.已拒绝 3.已过期 -->
                                <div class="pendApproval" v-if="item.state == 0">
                                    <img src="@/assets/img/Slice154.png" alt="" class="pendApproval_img" >
                                    <span class="pendApproval_text">{{ $t('adhibition.pendApproval') }}</span>
                                </div>
                                <div class="pendApproval" v-if="item.state == 2 && !item.reapply">
                                    <img src="@/assets/img/Slice155.png" alt="" class="pendApproval_img" >
                                    <span class="pendApproval_text">{{ $t('adhibition.refused') }}</span>
                                </div>

                                <v-radio :label="item.name" :disabled = "item.state == 0 || item.state == 1 || (item.state == 2 && !item.reapply) ? true : false" :title="item.name" :value="item.id" @click="changeRadio(item)"></v-radio>
                            </div>
                        </v-col>
                    </template>
                    <template v-else>
                        <div class="noData">
                            <img src="@/assets/img/Slice170.png" alt="" >
                            <span>{{$t("adhibition.noData")}}</span>
                        </div>
                    </template>
                </div>
            </v-radio-group>
            <p v-if="errorSelect" class="errorMessage">{{ $t('adhibition.pleaseSelectType') }}</p>
            <p class="approvalDes"  :class="$vuetify.theme.dark ? 'p-dark':''" v-if="form.appSelect && requireApprovalFlag">{{ $t('adhibition.applyReasonRequire') }}</p>
            <p class="approvalDes"  :class="$vuetify.theme.dark ? 'p-dark':''" v-if="form.appSelect && !requireApprovalFlag">{{ $t('adhibition.noRequireReason') }}</p>
            <v-textarea
                v-if="form.appSelect && requireApprovalFlag"
                v-model="form.applyReason"
                filled
                auto-grow
                :label="$t('adhibition.applyReason')"
                :placeholder="$t('adhibition.placePutReason')"
                rows="4"
                :rules="applyAppForm.appReason"
                row-height="25"
                shaped
                required
            ></v-textarea>
            <v-row no-gutters>
                <v-col cols="12" class="mb-2 mt-2">
                    <v-btn color="primary" @click="onSubmitApply" small>{{$t('btn.commit')}}</v-btn>
                    <v-btn class="close_btn" outlined @click="close" small>{{$t('btn.close')}}</v-btn>
                </v-col>
            </v-row>
        </v-form>
    <!-- </a-spin> -->
</template>

<script>
import { reqGetPermissionApp, reqAppApply } from "@/api/index";
import { mdiEyeOutline, mdiEyeOffOutline, mdiViewGridOutline,mdiFileAlertOutline  } from '@mdi/js';
import store from '@/store'

export default {
    data() {
        return {
            isLoading:true,
            valid: false,
            form: {},
            icons: {
                mdiEyeOutline,
                mdiEyeOffOutline,
                mdiViewGridOutline,
                mdiFileAlertOutline
            },
            errorMessage: undefined,
            phoneErrMsg: undefined,
            applyAppForm:
                {
                    // appType: [
                    //     v => !!v || this.$t('adhibition.pleaseSelectType'),
                    // ],
                    appReason: [
                        v => !!v || this.$t('adhibition.pleaseApplyReason'),
                        v => (v && v.length <= 200) || this.$t('adhibition.applyReasonMaxLength')
                    ],
                },
            codeText: this.$t('account.getCode'),
            spinning: false,
            appSelectData:[],
            requireApprovalFlag:null,
            errorSelect:false
        };
    },
    props: {
        selectedProduct:{
            type:Number,
            default:null
        }
    },
    mounted() {
        this.initPermissionApp()
    },
    created() {
    },
    watch: {

    },
    methods: {
        initPermissionApp(){
            reqGetPermissionApp().then(res => {
                if(res.code == 200){
                    this.isLoading = false
                    this.appSelectData = res.data
                }else{
                    this.appSelectData = []
                    store.dispatch('snackbar/openSnackbar',{
                        snackbarText: res.message,
                        colorType: 'error'
                    })
                }
            })
        },
        onSubmitApply() {
            if(this.appSelectData.length>0){
                if(this.form.appSelect){
                    this.errorSelect = false
                    if(this.$refs.applyForm.validate()){
                        let params = {
                            "appIds":[this.form.appSelect],
                            "reasonForApplication":this.form.applyReason ? this.form.applyReason : '',
                            "groupId":this.selectedProduct ? this.selectedProduct : ''
                        }
                        reqAppApply(params).then(res=> {
                            if (res.code == this.$GLOBA.StatusOK) {
                                store.dispatch('snackbar/openSnackbar',{
                                    snackbarText: res.message,
                                    colorType: 'success'
                                })
                                this.$emit("close")
                                this.$emit("initProductGroup")
                            }else{
                                store.dispatch('snackbar/openSnackbar',{
                                    snackbarText: res.message,
                                    colorType: 'error'
                                })
                            }
                        })
                    }else{
                        return false;
                    }
                }else{
                    this.errorSelect = true
                }

            }else{
                this.$emit("close")
            }
        },
        close() {
            this.$emit("close")
        },
        changeRadio(val){
            this.$refs.applyForm.resetValidation()
            if(this.form.appSelect){
                this.errorSelect = false
            }else{
                this.errorSelect = true
            }
            // 判断该应用需要审批的话，显示申请原因输入框
            if(val.whetherApproval){
                this.requireApprovalFlag = true
            }else{
                this.requireApprovalFlag = false
            }
        }
    },
};
</script>

<style scoped lang="scss">
::v-deep .ant-input-group-addon {
    min-width: 93px;
    background: none;
}
.get-code {
    cursor: pointer;
    color: #5066e0;
}
.code-btn ::v-deep .ant-input {
    border-right: 0;
}


.formStyle{
    .login-index-loading-box{
        width: 100%;
        text-align: center;
    }
    .appSelect_box{
        // width: 183px;
        height: 68px;
        background: #F6F7F9;
        padding: 15px;
        position: relative;
        .appImg{
            width:36px;
            height:36px;
            float: left;
            object-fit: cover;
        }
        .pendApproval{
            position: absolute;
            left: 30px;
            top: 3px;
            .pendApproval_img{
                width: 50px;
            }
            .pendApproval_text{
                position: absolute;
                left: 6px;
                font-size: 10px;
                color: #fff;
                top: 2px;
            }
        }
    }

    .list-dark ::v-deep {
      .appSelect_box {
        background:  #3B355A !important;
          .theme--dark {
            .theme--dark{
              color: rgba(231, 227, 252, 0.67) !important;
            }
        }
        .v-radio--is-disabled{
            .theme--dark{
              color: rgba(231, 227, 252, 0.25) !important;
            }
        }

      }

    }

    .topBox{
        max-height: 179px;
        overflow: auto;
        display: flex;
        flex-wrap: inherit;
        width: 100%;
        .colStyle{
            padding: 8px 8px 8px 0px;
        }
    }
    .selectBox{
        width: 25%;
        padding: 0 10px 15px 10px;
    }
    .approvalDes{
        width: 100%;
        padding: 10px 10px 10px 10px;
        background: #F2F3F5;
        color: #666;
        text-align: left;
    }
  .approvalDes.p-dark {
    background:  #3B355A !important;
    color: rgba(231, 227, 252, 0.67) !important;
  }
}
::v-deep {
    .v-input--selection-controls__input{
        position: relative;
        right: -100%;
        top: -9px;
    }
    .v-input--selection-controls .v-radio > .v-label{
        left: -20px !important;
        max-width: 100px;
        // border: 1px solid;
        top: 6px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
        color: #333;
        font-size: 16px;
    }
    .theme--light.v-radio--is-disabled label{
        color: rgba(94, 86, 105, 0.35) !important;
    }
    .v-input--radio-group legend.v-label{
        width: 100%;
        margin-bottom: 10px;
        padding-left: 7px;
        color: #333;
        font-size: 16px;
    }
    .v-radio--is-disabled .v-icon{
        color: rgba(94, 86, 105, 0.25);
    }
    .v-text-field--shaped{
        border-radius: 0;
    }
}

::v-deep .row {
    align-items: start !important;
}
.close_btn{
    margin-left: 10px;
}
@media screen and (min-width: 320px) and (max-width: 480px){
    .close_btn{
        margin-left: 6px;
    }
    ::v-deep {
        .v-text-field.v-text-field--enclosed .v-text-field__details{
            padding: 0;
        }
    }
    .formStyle{
        width: 100%;
        margin-left: 0%;
        margin-top: 10px;
    }
}
::-webkit-scrollbar {
    display: none;
}
.noData{
    width: 100%;
    // height: 70px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.selectTitle{
    text-align: left;
    font-size: 16px;
    margin-bottom: -16px;
    color: #333;
    padding-left: 5px;
}
.errorMessage{
    text-align: left;
    color: red;
    padding-left: 10px;
}
.logo-pic{
    width: 36px !important;
    max-height:  36px !important;
}
</style>
